<div *ngIf="isReady">
    <div class="mb-3 p-3 rounded border bg-white shadow-sm">
        <form [formGroup]="preferenceForm">

            <div class="row" *ngIf="eventInfoWithConsent?.isShowSalePersonForInvestorRegistration && showInvitedBy">
                <div class="col-6 pb-2 mt-2">
                    <div id="investor-register-field-cohost-text" class="pb-1">Invited by <span class="text-danger">*</span></div>
                        <ng-select 
                            id="investor-register-field-cohost-selector" 
                            name="coHost" 
                            id="coHost" 
                            placeholder="Please Select"
                            formControlName="coHostName" 
                            excludeTh>
                            <ng-option *ngFor="let item of listInvited" [value]="item.name">{{item.name}}</ng-option>
                        </ng-select>
                        <small id="investor-register-field-cohost-required-error-text" class="invalid-input" *ngIf="f.coHostName.touched && f.coHostName.invalid">
                            Name is required
                        </small>
                </div>
                <div class="col-6 pb-2 mt-2"></div>
                <div class="col-6 pb-2 mt-2" *ngIf="checkSelectedCoHostIsOthers()">
                    <input 
                    id="investor-register-field-broker-name-input" 
                    type="text" 
                    class="form-control" 
                    placeholder="Please Specify"
                    formControlName="brokerName"
                    required
                    englishInput>
                    <small id="investor-register-field-broker-name-required-error-text" class="invalid-input" *ngIf="f.brokerName.touched && f.brokerName.invalid">
                        Securities Name is required
                    </small>
                </div>
            </div>

            <div class="row" *ngIf="eventInfoWithConsent?.eventType === 'THAILAND_FOCUS'">
                <ng-container *ngIf="eventInfoWithConsent?.isSubEvent">
                    <div class="col-6 pb-2 mt-2">
                        <label id="investor-register-form-field-seminar-session-text">
                            {{ eventInfoWithConsent?.seminarStartDate 
                            ? 'Seminar Session on ' + (eventInfoWithConsent.seminarStartDate | date: 'EEEE, MMMM dd, yyyy':'UTC+7')
                            : 'Seminar Session' }}
                        </label>
                        <div>
                            <div class="form-check form-check-inline">
                                <input 
                                    class="form-checkbox"
                                    type="checkbox" 
                                    id="attended-checkbox" 
                                    formControlName="seminarSubEvent">
                                <label for="attended-checkbox" class="form-check-label">Attended</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 pb-2 mt-2"></div>
                </ng-container>
        
                <div class="col-6 pb-2 mt-2">
                    <label id="investor-register-field-attendance-preference-text">
                        {{
                        eventInfoWithConsent?.isSubEvent
                        ? (eventInfoWithConsent?.slotEndDate ? 'Corporate Briefing on ' + (eventInfoWithConsent.slotEndDate | date: 'EEEE, MMMM dd, yyyy':'UTC+7') : 'Corporate Briefing')
                        : 'Attendance Preference'
                        }}
                        <span class="text-danger">*</span>
                    </label>
                    <div>
                        <div class="form-check form-check-inline">
                            <label class="form-check-label">
                                <input 
                                    id="physical-radio"
                                    class="form-radio"
                                    type="radio" 
                                    formControlName="attendancePreference"
                                    [value]="attendanceEnum.PHYSICAL" >
                                        Physical (On-site)
                            </label>
                        </div>
                        <div class="form-check form-check-inline" *ngIf="!eventInfoWithConsent?.isSubEvent">
                            <label class="form-check-label">
                                <input 
                                    id="virtual-radio" 
                                    class="form-radio ml-3"
                                    type="radio" 
                                    formControlName="attendancePreference"
                                    [value]="attendanceEnum.VIRTUAL" >
                                        Virtual (Online)
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>